const moment = require('moment')
require('moment-timezone')

/**
 * The zone-sensitive calculations behind `dateUtil`, with no application dependencies.
 *
 * `dateUtil` imports `@/i18n`, which pulls in Vue and the locale files and cannot be loaded by the
 * `node --test` harness. These four calculations are the ones that actually broke in production
 * (see [T2], [T3] and [U10] in `docs/backlog.md`), so they live here where a test can import the
 * real implementation instead of restating it — a test that restates the code under test passes
 * even after you delete that code.
 *
 * Application code keeps calling `dateUtil`; this module is its engine, not a second entry point.
 *
 * CommonJS on purpose: Node 20 cannot `require()` an ES module, and the regression harness
 * (`node --test`) has to load this file directly. Webpack imports it from `dateUtil` unchanged.
 */

/** Returns null for an unknown zone id, which is how the caller detects a misconfigured build. */
function resolveZone (timezone) {
  return moment.tz.zone(timezone)
}

/** Today in `timezone` as `YYYY-MM-DD`. Never derive this from `toISOString()`, which is UTC. */
function todayForSystem (timezone, now = undefined) {
  return moment(now).tz(timezone).format('YYYY-MM-DD')
}

/** `YYYY-MM-DD` of an instant, in `timezone`. */
function formatDateForSystem (timezone, date) {
  return moment(date).tz(timezone).format('YYYY-MM-DD')
}

/** Day of week in `timezone`, ISO numbering: 1 = Monday … 7 = Sunday. */
function isoWeekday (timezone, date) {
  return moment(date).tz(timezone).isoWeekday()
}

/**
 * Shift by real minutes. `Date.setMinutes(getMinutes() + n)` does the arithmetic on local clock
 * fields instead, so it moves by an extra hour across a daylight-saving change.
 */
function addMinutes (timezone, date, minutesToAdd) {
  return moment(date).tz(timezone).add(minutesToAdd, 'minutes').toDate()
}

module.exports = {
  resolveZone,
  todayForSystem,
  formatDateForSystem,
  isoWeekday,
  addMinutes
}
